export const VIDEO_CARD_ITEM_TYPES = {
    DISCOUNT: 'discount',
    IMAGE: 'image',
    QUOTE: 'quote',
    IMAGE_BRAND: 'imageBrand',
    CTA_BLOCK: 'CTABlock',
} as const;

export type VIDEO_CARD_ITEM_TYPE = typeof VIDEO_CARD_ITEM_TYPES[keyof typeof VIDEO_CARD_ITEM_TYPES];
